module.exports = __webpack_public_path__ + "static/media/google-play-logo.0969969f.jpg";